export default __webpack_public_path__ + "images/icons/tiktok-d4b948c7151707d3b6c806882077d62c.svg";